import React, { useEffect, useMemo, useRef, useState } from 'react'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
import Select from 'react-select'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import SavePatients from '../../services/general/savePatientinformation.api.js'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientAppointmentDetails from '../../services/general/appointmentData.api.js'
import { CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell,CCardHeader ,CCardBody , CTableRow, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CCard } from '@coreui/react'
import Pageloader from '../../components/shared/Pageloader.jsx'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api.js'
import { batchGetPatientNotes } from '../../services/general/patientNoteData.batch.js'
import Topper from '../../components/shared/Topper.jsx'
import { CChart } from '@coreui/react-chartjs'
import { ChevronDown } from 'lucide-react'
import  '../dashboard/dashboard.css'

import { useHistory } from 'react-router-dom'

import providerCredentialingCRUD from '../../services/general/ProviderCredentialingCRUD.api.js'
import RegisterUser from "../../services/general/register.api";
const Analytics = () => {
  const history = useHistory()
  const [filterData, setFilterData] = useState({
    facility: [],
    providers: [],
    date: '',
    type: '',
  })

  useEffect(() => {
    const today = new Date()
    const mm = String(today.getMonth() + 1).padStart(2, '0') // months are 0-based
    const dd = String(today.getDate()).padStart(2, '0')
    const yyyy = today.getFullYear()

    const formattedDate = `${mm}/${dd}/${yyyy}`

    setFilterData((prev) => ({
      ...prev,
      date: formattedDate,
    }))
  }, [])

  const [statsValue, setStatsValue] = useState({
    totalAppointments: 0,
    totalFinishedAppointments: 0,
    totalSignedAppointments: 0,
    totalNotSignedAppointments: 0,
    totalLeftAppointments: 0,
    totalNotSeenAppointments: 0,
  })
  const [facilities, setFacilities] = useState([])
  const [patientData, setPatientData] = useState('')
  const [providerList, setProviderList] = useState([])
  const [appointments, setAppointments] = useState([])
  const [, setAllAppointment] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [activeTab, setActiveTab] = useState("overview");
  const [analyticsTheme, setAnalyticsTheme] = useState(() => localStorage.getItem('provio_theme') || 'dark')
  const analyticsChartTextColor = analyticsTheme === 'light' ? '#212529' : '#d1d5db'
  const analyticsChartGridColor = analyticsTheme === 'light' ? 'rgba(33, 37, 41, 0.18)' : 'rgba(255, 255, 255, 0.16)'
  const [credentialTasks, setCredentialTasks] = useState([]);
  const [pendingTasks, setPendingTasks] = useState([])
   const [users, setUsers] = useState([])
  const appointmentNotesRequestRef = useRef(0)
  const [loadingStates, setLoadingStates] = useState({
    fetchingFacilities: false,
    fetchingProviders: false,
    fetchingAppointments: false,
    calculatingStats: false,
    fetchingPatientData: false,
    fetchingPatients: false,
    calculatingFacilityStats: false,
    fetchingCredentialTasks: false,
  })
  useEffect(() => {
    const handleThemeChange = () => {
      setAnalyticsTheme(localStorage.getItem('provio_theme') || 'dark')
    }

    window.addEventListener('storage', handleThemeChange)
    window.addEventListener('provio-theme-change', handleThemeChange)

    return () => {
      window.removeEventListener('storage', handleThemeChange)
      window.removeEventListener('provio-theme-change', handleThemeChange)
    }
  }, [])

  useEffect(() => {
    document.body.classList.add('analytics-theme-page')
    document.body.classList.toggle('analytics-theme-page--dark', analyticsTheme !== 'light')

    return () => {
      document.body.classList.remove('analytics-theme-page', 'analytics-theme-page--dark')
    }
  }, [analyticsTheme])
const credentialChartOptions = {
  responsive: true,
  maintainAspectRatio: false,

  plugins: {
    legend: {
      display: false,
    },
  },

  scales: {
    x: {
      grid: {
        color: analyticsChartGridColor,
      },
      ticks: {
        color: analyticsChartTextColor,
      },
    },
    y: {
      beginAtZero: true,
      grid: {
        color: analyticsChartGridColor,
      },
      ticks: {
        precision: 0,
        color: analyticsChartTextColor,
      },
    },
  },
};
  const patientDataFn = async () => {
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      setPatientData(JSON.parse(patientData.d).Data)
    } catch (error) {}
  }

  useEffect(() => {
    const loadPatients = async () => {
      setLoadingStates((prev) => ({ ...prev, fetchingPatients: true }))
      try {
        await patientDataFn()
      } finally {
        setLoadingStates((prev) => ({ ...prev, fetchingPatients: false }))
      }
    }

    loadPatients()
  }, [])

  const getFacilities = async () => {
    try {
      let a = await FacilityCRUD('SELECT', {})
      let data = JSON.parse(a.d)?.Data
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
      }))
      setFacilities(formattedData)
      setSelectedFacility(formattedData[0])
    } catch (e) {}
  }

  useEffect(() => {
    const loadFacilities = async () => {
      setLoadingStates((prev) => ({ ...prev, fetchingFacilities: true }))
      try {
        await getFacilities()
      } finally {
        setLoadingStates((prev) => ({ ...prev, fetchingFacilities: false }))
      }
    }

    loadFacilities()
  }, [])

  const getAppointmentData = async () => {
    setIsPageLoading(true)
    const requestId = ++appointmentNotesRequestRef.current

    try {
      const result = await PatientAppointmentDetails('GET', '', '', '', '')

      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '');
      const rawData = JSON.parse(result.d)?.Data || []

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
            setIsPageLoading(false)
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      setAllAppointment(structuredData)

      let flatAppointments = structuredData.flatMap((p) => p.appointmentDetails)
      const uniquePatientIDs = [...new Set(flatAppointments.map((item) => item.data.PatientID))]

      const appointmentsWithoutNoteStatus = flatAppointments.map((appointment) => ({
        ...appointment,
        data: {
          ...appointment.data,
          hasSignedNote: false,
          noteMatch: null,
        },
      }))

      setAppointments(appointmentsWithoutNoteStatus)

      if (uniquePatientIDs.length > 0) {
        void (async () => {
          try {
            const batchResults = await batchGetPatientNotes(uniquePatientIDs, { concurrency: 5 })

            if (appointmentNotesRequestRef.current !== requestId) {
              return
            }

            const updatedPatients = uniquePatientIDs.map((patientId) => {
              const dataResponse = batchResults.get(String(patientId).trim())
              const parsedData = dataResponse?.d ? (JSON.parse(dataResponse.d)?.Data || []) : []
              return {
                patientId,
                allNotes: parsedData,
              }
            })

            const appointmentsWithNotesStatusSigned = flatAppointments.map((appointment) => {
              const patientNotes = updatedPatients.find((p) => p.patientId === appointment.data.PatientID)

              const matchingNote = patientNotes?.allNotes?.find((note) => note.id === appointment.data.NoteID)

              return {
                ...appointment,
                data: {
                  ...appointment.data,
                  hasSignedNote: (matchingNote?.status?.toLowerCase() === 'signed' && matchingNote?.flag === 'true') || false,
                  noteMatch: matchingNote
                    ? {
                        id: matchingNote.id,
                        status: matchingNote.status,
                        flag: matchingNote.flag,
                      }
                    : null,
                },
              }
            })

            setAppointments(appointmentsWithNotesStatusSigned)
          } catch (err) {
            console.error('Unexpected error:', err)
          }
        })()
      }

      return flatAppointments
    } catch (error) {
    } finally {
      setIsPageLoading(false)
    }
  }

  useEffect(() => {
    const loadAppointments = async () => {
      setLoadingStates((prev) => ({ ...prev, fetchingAppointments: true }))
      try {
        await getAppointmentData()
      } finally {
        setLoadingStates((prev) => ({ ...prev, fetchingAppointments: false }))
      }
    }

    loadAppointments()
  }, [])

  const getProviders = async () => {
    setIsPageLoading(true)

    try {
      // Fetch provider data
      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      setProviderList(providerData)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const providerOptions = providerList.map((provider) => ({
    value: provider.ID,
    label: `${provider.Name}`, // what shows in dropdown
  }))

  useEffect(() => {
    const loadProviders = async () => {
      setLoadingStates((prev) => ({ ...prev, fetchingProviders: true }))
      try {
        await getProviders()
      } finally {
        setLoadingStates((prev) => ({ ...prev, fetchingProviders: false }))
      }
    }

    loadProviders()
  }, [])

  const [allProviderGroupedStats, setAllProviderGroupedStats] = useState([])
  const [facilityGroupedStats, setFacilityGroupedStats] = useState([])

  useEffect(() => {
    let filterAppointments = appointments.filter((appt) => {
      const facilityMatch = filterData.facility.length === 0 || filterData.facility.includes(appt.data.Facility)

      const providerMatch = filterData.providers.length === 0 || filterData.providers.includes(appt.data.ProviderName)

      const dateMatch = !filterData.date || new Date(appt.data.StartTime).toDateString() === new Date(filterData.date).toDateString()

      return facilityMatch && providerMatch && dateMatch
    })

    const getProvidersStats = (providerList, appointments) => {
      let filteredProviders = providerList
      if (filterData.providers?.length > 0) {
        filteredProviders = providerList.filter((provider) => filterData.providers.includes(provider.ID) || filterData.providers.includes(provider.Name))
      }

      return filteredProviders.map((provider) => {
        let providerAppointments = appointments.filter((appt) => appt.data.ProviderName === provider.Name)

        if (filterData.facility?.length > 0) {
          providerAppointments = providerAppointments.filter((appt) => filterData.facility.includes(appt.data.Facility))
        }

        if (filterData.date) {
          providerAppointments = providerAppointments.filter((appt) => new Date(appt.data.StartTime).toDateString() === new Date(filterData.date).toDateString())
        }

        if (filterData.type) {
          if (filterData.type === 'Signed') {
            providerAppointments = providerAppointments.filter((appt) => appt.data.hasSignedNote)
          }
        }

        return {
          id: provider.ID,
          name: provider.Name,
          totalAppointments: providerAppointments.length,
          notSeenAppointments: providerAppointments.filter((appt) => appt.data.patientSeen === false && appt.data.ProviderName === provider.Name).length,
          totalSignedAppointments: providerAppointments.filter((appt) => appt.data.hasSignedNote && appt.data.patientSeen !== false && appt.data.ProviderName === provider.Name).length,
          totalNotSignedAppointments: providerAppointments.filter((appt) => !appt.data.hasSignedNote && appt.data.ProviderName === provider.Name && appt.data.patientSeen !== false).length,
          totalLeftAppointments: filterAppointments.filter((appt) => ['scheduled', 'rescheduled', 'canceled', 'Draft'].includes(appt.data.Status?.toLowerCase()) && appt.data.patientSeen !== false && appt.data.ProviderName === provider.Name).length,
          finishedAppointments: providerAppointments.filter((appt) => appt.data.Status?.toLowerCase() === 'finish' || (appt.data.Status?.toLowerCase() === 'finished' && appt.data.ProviderName === provider.Name)).length,
        }
      })
    }

    const providerStats = getProvidersStats(providerList, appointments)
    setAllProviderGroupedStats(providerStats)

    const totalAppointments = filterAppointments.length

    if (filterData.type) {
      if (filterData.type === 'Signed') {
        filterAppointments = filterAppointments.filter((appt) => appt?.data?.hasSignedNote)
      }
    }

    const totalFinishedAppointments = filterAppointments.filter((appt) => ['finish', 'finished'].includes(appt.data.Status?.toLowerCase())).length

    const totalNotSeenAppointments = filterAppointments.filter((appt) => appt.data.patientSeen === false).length
    const totalSignedAppointments = filterAppointments.filter((appt) => appt.data.hasSignedNote && appt.data.patientSeen !== false).length
    const totalNotSignedAppointments = filterAppointments.filter((appt) => !appt.data.hasSignedNote && appt.data.patientSeen !== false).length

    const totalLeftAppointments = filterAppointments.filter((appt) => ['scheduled', 'rescheduled', 'canceled', 'Draft'].includes(appt.data.Status?.toLowerCase()) && appt.data.patientSeen !== false).length

    setStatsValue((prev) => ({
      ...prev,
      totalAppointments,
      totalLeftAppointments,
      totalNotSeenAppointments,
      totalFinishedAppointments,
      totalSignedAppointments,
      totalNotSignedAppointments,
    }))
  }, [filterData, appointments, providerList])

  const [filterDataFacility, setFilterDataFacility] = useState({
    facility: [],
    date: '',
    dateFrom: '',
    dateTo: '',
    search: '',
  })

  useEffect(() => {
    let filteredFacilities = facilities

    if (filterDataFacility.facility.length > 0) {
      filteredFacilities = facilities.filter((fac) => filterDataFacility.facility.includes(fac?.label))
    }
    if (filterDataFacility.search) {
      const searchTerm = filterDataFacility.search.toLowerCase()
      filteredFacilities = filteredFacilities.filter((fac) => fac?.label.toLowerCase().includes(searchTerm))
    }

    const mapFacilityStats = filteredFacilities.map((fac) => {
      let facilityAppointments = appointments.filter((appt) => appt.data.Facility === fac?.label)

      if (filterDataFacility.dateFrom || filterDataFacility.dateTo) {
        facilityAppointments = facilityAppointments.filter((appt) => {
          const apptDate = new Date(appt.data.StartTime)
          const from = filterDataFacility.dateFrom ? new Date(filterDataFacility.dateFrom) : null
          const to = filterDataFacility.dateTo ? new Date(filterDataFacility.dateTo) : null

          if (from && to) {
            return apptDate >= from && apptDate <= to
          } else if (from) {
            return apptDate >= from
          } else if (to) {
            return apptDate <= to
          }
          return true
        })
      }

      let facilityPatients = (Array.isArray(patientData) && (patientData || []).filter((patient) => patient.FacilityName === fac?.label)) || []

      if (filterDataFacility.patientCreatedDate) {
        facilityPatients = facilityPatients.filter((patient) => new Date(patient.createdDate).toDateString() === new Date(filterDataFacility.patientCreatedDate).toDateString())
      }

      const totalFacilityPatients = facilityPatients.length

      const totalFacilityPatientList = facilityPatients

      const scheduledPatientIDs = new Set(facilityAppointments.map((appt) => appt.data.PatientID))

      const scheduledPatients = facilityPatients.filter((patient) => scheduledPatientIDs.has(patient.PatientID)).length

      const totalFollowUpPatients = facilityPatients.filter((patient) => patient.Status === 'Follow Up').length
      const totalFollowUpPatientsList = facilityPatients.filter((patient) => patient.Status === 'Follow Up')

      const totalNewPatients = facilityPatients.filter((patient) => patient.Status === 'NewPatient').length
      const totalNewPatientsList = facilityPatients.filter((patient) => patient.Status === 'NewPatient')

      const notScheduledPatients = facilityPatients.filter((patient) => !scheduledPatientIDs.has(patient.PatientID)).length

      const notScheduledPatientsList = facilityPatients.filter((patient) => !scheduledPatientIDs.has(patient.PatientID))

      const totalNotSeenPatientAppointments = facilityAppointments.filter((appt) => appt.data.patientSeen === false && appt.data.notSeenReason !== 'Discharged').length

      const notSeenPatientAppointmentsList = facilityAppointments.filter((appt) => appt.data.patientSeen === false && appt.data.notSeenReason !== 'Discharged')

      return {
        FacilityName: fac?.label,
        totalFacilityPatients,
        totalNotSeenPatientAppointments,
        totalFacilityPatientList,
        totalFollowUpPatients,
        scheduledPatients,
        totalNewPatients,
        notScheduledPatients,
        notScheduledPatientsList,
        totalNewPatientsList,
        totalFollowUpPatientsList,
        notSeenPatientAppointmentsList,
      }
    })

    setFacilityGroupedStats(mapFacilityStats)
  }, [patientData, appointments, facilities, filterDataFacility])

  useEffect(() => {
    const today = new Date()

    const dayOfWeek = today.getDay()

    const firstDayOfWeek = new Date(today)
    firstDayOfWeek.setDate(today.getDate() - dayOfWeek + 1)

    const lastDayOfWeek = new Date(today)
    lastDayOfWeek.setDate(today.getDate() - dayOfWeek + 7)

    const formatDate = (date) => {
      const mm = String(date.getMonth() + 1).padStart(2, '0')
      const dd = String(date.getDate()).padStart(2, '0')
      const yyyy = date.getFullYear()
      return `${mm}/${dd}/${yyyy}`
    }

    setFilterDataFacility((prev) => ({
      ...prev,
      dateFrom: formatDate(firstDayOfWeek),
      dateTo: formatDate(lastDayOfWeek),
    }))
    setLoadingStates((prev) => ({ ...prev, calculatingFacilityStats: false }))
  }, [])

  const searchOptions = useMemo(
    () => ({
      width: '300px',
      // label: "Search",
      placeholder: 'Search Facility',
      value: filterDataFacility.search || '',
      type: 'text',
      onChange: (e) => {
        setFilterDataFacility((p) => ({
          ...p,
          search: e.target.value,
        }))
      },
    }),
    [filterDataFacility.search],
  )

  const selectDates = useMemo(
    () => [
      {
        label: 'Date from',
        value: filterDataFacility.dateFrom || '',
        onChange: (e) => {
          setFilterDataFacility((p) => ({
            ...p,
            dateFrom: e,
          }))
        },
        isMulti: false,
      },
      {
        label: 'Date to',
        value: filterDataFacility.dateTo || '',
        onChange: (e) => {
          setFilterDataFacility((p) => ({
            ...p,
            dateTo: e,
          }))
        },
        isMulti: false,
      },
    ],
    [filterDataFacility.dateFrom, filterDataFacility.dateTo],
  )

  const [showList, setShowList] = useState(false)
  const [selectedFacility, setSelectedFacility] = useState('')
  const [listFacility, setListFacility] = useState([])

  const [showNotSeenModal, setShowNotSeenModal] = useState(false)
  const [notSeenListArr, setNotSeenListArr] = useState([])

  const chartRef = useRef(null)

  const data = {
    labels: [`Total (${statsValue?.totalAppointments})`, `Signed (${statsValue?.totalSignedAppointments})`, `Not seen (${statsValue?.totalNotSeenAppointments})`, `Not signed (${statsValue?.totalNotSignedAppointments})`],
    datasets: [
      {
        label: 'Patient Stats',
        backgroundColor: '#5CC483',
        borderColor: '#5CC483',
        data: [statsValue?.totalAppointments, statsValue?.totalSignedAppointments, statsValue?.totalNotSeenAppointments, statsValue?.totalNotSignedAppointments],
        maxBarThickness: 30,
      },
    ],
  }

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: analyticsChartTextColor,
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: analyticsChartGridColor,
        },
        borders: {
          color: analyticsChartGridColor,
        },
        ticks: {
          color: analyticsChartTextColor,
        },
      },
      y: {
        grid: {
          color: analyticsChartGridColor,
        },
        ticks: {
          color: analyticsChartTextColor,
        },
        type: 'category',
      },
    },
  }

  const chartRefSecond = useRef(null)
  const dataSecond = {
    labels: allProviderGroupedStats?.map((item) => item.name), // provider names
    datasets: [
      {
        label: 'Total',
        data: allProviderGroupedStats?.map((item) => item.totalAppointments),
        backgroundColor: '#5CC483', // green
      },        
      {
        label: 'Signed',
        data: allProviderGroupedStats?.map((item) => item.totalSignedAppointments),
        backgroundColor: '#3498db', // blue
      },
      {
        label: 'Not Seen',
        data: allProviderGroupedStats?.map((item) => item.notSeenAppointments),
        backgroundColor: '#f1c40f', // yellow
      },
      {
        label: 'Not Signed',
        data: allProviderGroupedStats?.map((item) => item.totalNotSignedAppointments),
        backgroundColor: '#e74c3c', // red
      },
    ],
  }

  const optionsSecon = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: analyticsChartTextColor,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { color: analyticsChartGridColor },
        ticks: { color: analyticsChartTextColor },
      },
      y: {
        stacked: true,
        grid: { color: analyticsChartGridColor },
        ticks: { color: analyticsChartTextColor },
      },
    },
  }
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }
// const pendingTasks = [
//   {
//     id: 1,
//     task: "Upload DEA License",
//     assignedTo: "John",
//     priority: "High",
//     due: "5 Days",
//     status: "Pending",
//   },
//   {
//     id: 2,
//     task: "Verify Insurance",
//     assignedTo: "Jane",
//     priority: "Medium",
//     due: "8 Days",
//     status: "Pending",
//   },
//   {
//     id: 3,
//     task: "Credential Expiry",
//     assignedTo: "Alex",
//     priority: "High",
//     due: "12 Days",
//     status: "Pending",
//   },
// ];
// const getPendingTasks = async () => {
//   let assignedUsers = [];
//   try {
//     const res = await DashboardTasks()

//     const data = JSON.parse(res.d)?.data || []
 

//    const tasks = data.map((item) => {
//   let assignedUsers = [];

//   try {
//     assignedUsers = JSON.parse(item.AssignedUsersJson || "[]");
//   } catch {
//     assignedUsers = [];
//   }

//   return {
//     id: item.TaskId,
//     task: item.Title,
//     assignedTo: assignedUsers.map(u => u.Username).join(", "),
//     priority: item.Priority,
//     due: `${item.PendingDays} Days`,
//     status: item.Status,
//   };
// });
//     setPendingTasks(tasks)
//   } catch (err) {
//     console.log(err)
//   }
// }
const statusCounts = useMemo(() => ({
  Total: credentialTasks.length,
  ToDo: credentialTasks.filter(x => x.status === "To Do").length,
  InProgress: credentialTasks.filter(x => x.status === "In Progress").length,
  Submitted: credentialTasks.filter(x => x.status === "Submitted").length,
  Completed: credentialTasks.filter(x => x.status === "Completed").length,
}), [credentialTasks]);

const credentialTaskChartData = {
  labels: ["Credentialing"],

  datasets: [
    {
      label: "To Do",
      data: [statusCounts.ToDo],
      backgroundColor: "#3B82F6",
    },
    {
      label: "In Progress",
      data: [statusCounts.InProgress],
      backgroundColor: "#F59E0B",
    },
    {
      label: "Submitted",
      data: [statusCounts.Submitted],
      backgroundColor: "#8B5CF6",
    },
    {
      label: "Completed",
      data: [statusCounts.Completed],
      backgroundColor: "#22C55E",
    },
  ],
};
const GetAllUsers = async () => {
    const response = await RegisterUser('', '', '', '', 'get_all')
    const parsedResponse = typeof response?.d === 'string' ? JSON.parse(response.d) : response?.d || response || {}

    const allUsers = parsedResponse?.Users || parsedResponse?.Data || parsedResponse?.data || []

    const formatted = allUsers.map(item => ({
        UserId: item.Id,
        Username: item.Username,
        value: item.Username,
        label: item.Username,
    }))

    setUsers(formatted)

    return formatted
}
const getUsernameById = (userId) => {
  const matchedUser = users.find((user) => {
    const id = user?.UserId ?? user?.userId ?? user?.id
    return String(id) === String(userId)
  })
console.log('matchedUser',matchedUser,userId)
  return matchedUser?.Username ?? matchedUser?.username ?? '-'
}

const getCredentialTasks = async (userList) => {
  try {
    const res = await providerCredentialingCRUD({}, '', 'GET_TASKS')
    const parsedResponse = typeof res?.d === 'string' ? JSON.parse(res.d) : res?.d || res || {}
    const data = parsedResponse?.data || parsedResponse?.Data || []

    const tasks = data.map((item) => ({
      provider: item.provider_name,
      assigned_to:
        userList.find((x) => String(x.UserId) === String(item.assigned_to))
          ?.Username || '-',
      status: item.status,
      days: item.PendingDays,
    }))

    setCredentialTasks(tasks)
  } catch (error) {
    console.error('Failed to load credential tasks', error)
    setCredentialTasks([])
  }
}

useEffect(() => {
  if (activeTab !== 'tasks') {
    return
  }

  let isMounted = true

  const loadTaskData = async () => {
    setLoadingStates((prev) => ({ ...prev, fetchingCredentialTasks: true }))

    try {
      const userList = await GetAllUsers()

      if (!isMounted) {
        return
      }

      await getCredentialTasks(userList)
    } catch (error) {
      console.error('Failed to load analytics tasks', error)
    } finally {
      if (isMounted) {
        setLoadingStates((prev) => ({ ...prev, fetchingCredentialTasks: false }))
      }
    }
  }

  loadTaskData()

  return () => {
    isMounted = false
  }
}, [activeTab])

// const credentialTasks = [
//   {
//     id: 1,
//     provider: "John Smith",
//     payer: "Aetna",
//     status: "In Progress",
//     days: 10,
//   },
//   {
//     id: 2,
//     provider: "Emily Davis",
//     payer: "Humana",
//     status: "Missing Docs",
//     days: 8,
//   },
// ];
  return (
    <>
    
      <div
        style={{
          width: '100%',
          borderRadius: '10px',
          minHeight: '90vh',
        }}
        className="analytics-shell position-relative p-3"
        data-theme={analyticsTheme}
      >
       <div className="dashboard-tabs">
  <button
    className={activeTab === "overview" ? "active" : ""}
    onClick={() => setActiveTab("overview")}
  >
    Analytics
  </button>

  <button
    className={activeTab === "tasks" ? "active" : ""}
    onClick={() => setActiveTab("tasks")}
  >
    Tasks
    {/* <span className="badge">12</span> */}
  </button>
</div>
{activeTab === "overview" && (
  <>
        <div className="py-4 gap-2 d-flex align-items-start justify-content-end">
          <div className="" style={{ width: 'max-content' }}>
            <CustomDatePickingFormat
              type="date"
              color="primary"
              value={filterData.date || ''}
              aria-describedby="exampleFormControlInputHelpInline"
              onChange={(e) => {
                setFilterData((p) => ({
                  ...p,
                  date: e, // Keep the date in "YYYY-MM-DD" format
                }))
              }}
            />
          </div>
         
          <div style={{ width: '300px' }}>
            <Select
              placeholder="Select Facility"
              name="facility"
              options={facilities}
              value={facilities.filter((fac) => filterData?.facility.includes(fac?.label))}
              isMulti
              isClearable
              onChange={(selectedOptions) =>
                setFilterData((prev) => ({
                  ...prev,
                  facility: selectedOptions ? selectedOptions.map((option) => option?.label) : [],
                }))
              }
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
          <div style={{ width: '300px' }}>
            <Select
              placeholder="Select Provider"
              name="facility"
              options={providerOptions}
              value={providerOptions.filter((option) => filterData.providers.includes(option?.label))}
              isMulti
              isClearable
              onChange={(selectedOptions) =>
                setFilterData((prev) => ({
                  ...prev,
                  providers: selectedOptions ? selectedOptions.map((option) => option?.label) : [],
                }))
              }
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
        </div>

        <div className="d-flex justify-between gap-4 mb-2">
          <CCard
            style={{
              boxShadow: '0px 0px 8px #e6e6e6',
              width: '100%',
              marginBottom: '30px',
              padding: '20px',
              height: '100%',
            }}
          >
            <CChart type="bar" height={200} data={data} options={options} ref={chartRef} />
          </CCard>
          <CCard
            style={{
              boxShadow: '0px 0px 8px #e6e6e6',
              width: '100%',
              marginBottom: '30px',
              padding: '20px',
              overflow: 'auto',
              height: expanded ? '1050px' : '242px',
            }}
          >
            <span onClick={toggleExpand} style={{ width: '100%', cursor: 'pointer' }} className="d-flex justify-content-end">
              <ChevronDown style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            </span>
            <CChart type="bar" data={dataSecond} options={optionsSecon} ref={chartRefSecond} height={500} style={{ width: '100%' }} />
          </CCard>
        </div>

        <div className="row ">
          <div
            className="col-sm-3 mb-3 mb-sm-0"
          >
            <div className="shadow card analytics-stat-card">
              <div className="card-body">
                <p className="m-0 p-0 analytics-stat-card__value">
                  {statsValue?.totalAppointments}
                </p>
                <h5 className="card-title">Total </h5>
              </div>
            </div>
          </div>
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => {
              // const data = {
              //     // facility: filterData.facility,
              //     // providers: [item?.name],
              //     scheduleDate: filterData.date
              // }
              // localStorage.setItem('analyticsFilter', JSON.stringify(data))
              // // window.open('/home/appointment')
              // window.location.replace('/home/appointment');
            }}
            className="col-sm-3 mb-3 mb-sm-0"
          >
            <div className="shadow card analytics-stat-card analytics-stat-card--toggle">
              <div
                className="card-body"
                onClick={() => {
                  if (filterData.type === 'Signed') {
                    setFilterData((p) => ({
                      ...p,
                      type: '',
                    }))
                  } else {
                    setFilterData((p) => ({
                      ...p,
                      type: 'Signed',
                    }))
                  }
                }}
              >
                <p className="m-0 p-0 analytics-stat-card__value">
                  {statsValue?.totalSignedAppointments}
                </p>
                <h5 className="card-title">Signed </h5>
              </div>
            </div>
          </div>
          <div
            className="col-sm-3 mb-3 mb-sm-0"
          >
            <div className="shadow card analytics-stat-card">
              <div className="card-body">
                <p className="m-0 p-0 analytics-stat-card__value">
                  {statsValue?.totalNotSeenAppointments}
                </p>
                <h5 className="card-title">Not Seen</h5>
              </div>
            </div>
          </div>
          <div
            className="col-sm-3 mb-3 mb-sm-0"
          >
            <div className="shadow card analytics-stat-card">
              <div className="card-body">
                <p className="m-0 p-0 analytics-stat-card__value">
                  {statsValue?.totalNotSignedAppointments}
                </p>
                <h5 className="card-title">Not Signed </h5>
              </div>
            </div>
          </div>
        </div>

        <div className="row provider-card-info">
          {allProviderGroupedStats
            .filter((item) => item?.totalAppointments > 0 || item?.totalSignedAppointments > 0 || item?.notSeenAppointments > 0 || item?.totalNotSignedAppointments > 0 || item?.totalLeftAppointments > 0)
            .map((item, idx) => {
              return (
                <div key={`${item?.id || item?.name || 'provider'}-${idx}`} className="col-sm-3 mb-3 mb-sm-0">
                  <div className="shadow card analytics-provider-card">
                    <div className="card-body">
                      <p className="m analytics-provider-card__name">
                        {item?.name}
                      </p>
                      <div />
                      <div className="analytics-provider-card__stats">
                        <div
                          className="d-flex flex-column stats-card-provider"
                        >
                          <span className="stats-card-provider-span">{item?.totalAppointments}</span>
                          <span className="stats-card-provider-second">Total</span>
                        </div>
                        <div className="d-flex flex-column stats-card-provider">
                          <span className="stats-card-provider-span">{item?.totalSignedAppointments}</span>
                          <span className="stats-card-provider-second">Signed</span>
                        </div>
                        <div className="d-flex flex-column stats-card-provider">
                          <span className="stats-card-provider-span">{item?.notSeenAppointments}</span>
                          <span className="stats-card-provider-second">Not Seen</span>
                        </div>
                        <div className="d-flex flex-column stats-card-provider">
                          <span className="stats-card-provider-span">{item?.totalNotSignedAppointments}</span>
                          <span className="stats-card-provider-second">Not Signed</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
        </div>

        <div>
          {allProviderGroupedStats.filter((item) => item?.totalAppointments > 0 || item?.totalSignedAppointments > 0 || item?.notSeenAppointments > 0 || item?.totalNotSignedAppointments > 0 || item?.totalLeftAppointments > 0).length === 0 && (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
              <h4>No Data Matches The Filter Applied</h4>
            </div>
          )}
        </div>

        <div className="analytics-patient-list">
          <div className="analytics-patient-list__filters">
            <Topper searchOptions={searchOptions} selectDates={selectDates} />
          </div>
          <div className="analytics-patient-list__table">
            <CTable className="mb-0">
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">#</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Facility</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Total Patient</CTableHeaderCell>
                  <CTableHeaderCell scope="col">New Patient</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Follow-up Patient</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Missed</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Not Scheduled Patient</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {facilityGroupedStats.map((facility, index) => {
                  return (
                    <CTableRow key={index}>
                      <CTableHeaderCell scope="row">{index + 1}</CTableHeaderCell>
                      <CTableDataCell
                        onClick={() => {
                          setShowList(true)
                          setSelectedFacility(facility.FacilityName)
                          setListFacility(facility.totalFacilityPatientList)
                        }}
                      >
                        {facility.FacilityName}
                      </CTableDataCell>
                      <CTableDataCell
                        onClick={() => {
                          setShowList(true)
                          setSelectedFacility(facility.FacilityName)
                          setListFacility(facility.totalFacilityPatientList)
                        }}
                      >
                        {facility.totalFacilityPatients}
                      </CTableDataCell>
                      <CTableDataCell
                        onClick={() => {
                          setShowList(true)
                          setSelectedFacility(facility.FacilityName)
                          setListFacility(facility.totalNewPatientsList)
                        }}
                      >
                        {facility.totalNewPatients}
                      </CTableDataCell>
                      <CTableDataCell
                        onClick={() => {
                          setShowList(true)
                          setSelectedFacility(facility.FacilityName)
                          setListFacility(facility.totalFollowUpPatientsList)
                        }}
                      >
                        {facility.totalFollowUpPatients}
                      </CTableDataCell>
                      <CTableDataCell
                        onClick={() => {
                          setShowNotSeenModal(true)
                          setSelectedFacility(facility.FacilityName)
                          const formattedPatients =
                            facility?.notSeenPatientAppointmentsList.length > 0 &&
                            facility?.notSeenPatientAppointmentsList?.map((item, index) => ({
                              id: index + 1,
                              patientName: item?.Patient?.label || item?.data?.AppointmentName || '',
                              startDate: item?.data?.StartTime?.split(' ')[0] ?? '',
                              notSeenReason: item?.data?.notSeenReason ?? '',
                              providerName: item?.data?.ProviderName ?? '',
                            }))
                          setNotSeenListArr(formattedPatients)
                        }}
                      >
                        {facility.totalNotSeenPatientAppointments}
                      </CTableDataCell>
                      <CTableDataCell
                        onClick={() => {
                          setShowList(true)
                          setSelectedFacility(facility.FacilityName)
                          setListFacility(facility.notScheduledPatientsList)
                        }}
                      >
                        {facility.notScheduledPatients}
                      </CTableDataCell>
                    </CTableRow>
                  )
                })}
              </CTableBody>
            </CTable>
          </div>
        </div>
        </>
)}

{activeTab === "tasks" && (
  <>
    {/* Summary Cards */}
<div className="task-dashboard">

    <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
            {/* <h2 className="task-title">Operations Overview</h2>
            <p className="task-subtitle">
                Review critical pending tasks and credentialing status.
            </p> */}
        </div>

        <div className="d-flex gap-2">
            {/* <CButton color="light">Filter</CButton> */}
            {/* <CButton color="primary">Export Report</CButton> */}
        </div>
    </div>
    </div>


<CCard className="mb-4">
  <CCardHeader>
    <strong>Credentialing Status Overview</strong>
  </CCardHeader>

  <CCardBody style={{ height: '350px' }}>
    <CChart
      type="bar" height={200} 
    data={credentialTaskChartData}
    options={credentialChartOptions}
    />
  </CCardBody>
</CCard>
  <div className="row "> 
<div className="col-md-2">
    <CCard className="shadow-sm">
      <div className="card-body">
        <h2>{statusCounts.Total}</h2>
        <p>Total</p>
      </div>
    </CCard>
  </div> 

  <div className="col-md-2">
    <CCard className="shadow-sm">
      <div className="card-body">
        <h2>{statusCounts.ToDo}</h2>
        <p>To Do</p>
      </div>
    </CCard>
  </div>

  <div className="col-md-2">
    <CCard className="shadow-sm">
      <div className="card-body">
        <h2>{statusCounts.InProgress}</h2>
        <p>In Progress</p>
      </div>
    </CCard>
  </div>
  <div className="col-md-2">
    <CCard className="shadow-sm">
      <div className="card-body">
        <h2>{statusCounts.Completed}</h2>
        <p>Completed</p>
      </div>
    </CCard>
  </div> 

   <div className="col-md-2">
    <CCard className="shadow-sm">
      <div className="card-body">
        <h2>{statusCounts.Submitted}</h2>
        <p>Archived </p>
      </div>
    </CCard>
  </div>

 </div>      

    {/* Credentialing */}

    <CCard className="p-3">

   <div className="dashboard-section-header d-flex justify-content-between align-items-center">
  <div>
    <h5>Pending Credentialing Tasks </h5>

    {/* {credentialTasks.length > 0 ? (
      <small className="text-muted">
        Credentialing tasks pending for more than 7 days
      </small>
    ) : (
      <small className="text-muted">
        No pending credentialing tasks
      </small>
    )} */}
  </div>

  {credentialTasks.length > 0 && (
    <CButton 
      color="primary" 
      size="sm" 
      className="analytics-action-btn"
      onClick={() => history.push('/home/credentialing')}
    >
      View All
    </CButton>
  )}
</div>

      <CTable hover responsive>

        <CTableHead>

          <CTableRow>

            <CTableHeaderCell>Provider</CTableHeaderCell>

            <CTableHeaderCell>Assigned To</CTableHeaderCell>

            <CTableHeaderCell>Status</CTableHeaderCell>

            <CTableHeaderCell>Days</CTableHeaderCell>

          </CTableRow>

        </CTableHead>

        <CTableBody>

          {credentialTasks.map(item => (

            <CTableRow key={item.id}>

              <CTableDataCell>{item.provider}</CTableDataCell>
              <CTableDataCell>{item.assigned_to}</CTableDataCell>
              <CTableDataCell>
                <span
                  className={`badge ${
                    item.status === "Missing Docs"
                      ? "bg-danger"
                      : "bg-info"
                  }`}>
                  {item.status}
                </span>
              </CTableDataCell>
              <CTableDataCell>{item.days} Days</CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
    </CCard>
  </> 
)}
        <CModal className="analytics-modal" data-theme={analyticsTheme} backdrop="static" scrollable visible={showList} size="lg" onClose={() => setShowList(false)} aria-labelledby="StaticBackdropExampleLabel">
          <CModalHeader>
            <CModalTitle id="StaticBackdropExampleLabel">{selectedFacility}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <CTable>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">#</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                  <CTableHeaderCell scope="col">DOB</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Age</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Patient Status</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {listFacility &&
                  listFacility.length > 0 &&
                  listFacility.map((item, index) => {
                    return (
                      <CTableRow key={index}>
                        <CTableHeaderCell scope="row">{index + 1}</CTableHeaderCell>
                        <CTableDataCell>
                          {item.FirstName} {item.LastName}
                        </CTableDataCell>
                        <CTableDataCell>{item.DOB}</CTableDataCell>
                        <CTableDataCell>{item.Age}</CTableDataCell>
                        <CTableDataCell>{item?.Status === 'NewPatient' ? 'New Patient' : item?.Status}</CTableDataCell>
                      </CTableRow>
                    )
                  })}
              </CTableBody>
            </CTable>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={() => setShowList(false)}>
              Close
            </CButton>
          </CModalFooter>
        </CModal>
      </div>

      <CModal className="analytics-modal" data-theme={analyticsTheme} backdrop="static" scrollable visible={showNotSeenModal} size="lg" onClose={() => setShowNotSeenModal(false)} aria-labelledby="StaticBackdropExampleLabel1">
        <CModalHeader>
          <CModalTitle id="StaticBackdropExampleLabel1">{selectedFacility && showNotSeenModal ? selectedFacility : ''}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CTable>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell scope="col">#</CTableHeaderCell>
                <CTableHeaderCell scope="col">Name</CTableHeaderCell>
                <CTableHeaderCell scope="col">Schedule Date</CTableHeaderCell>
                <CTableHeaderCell scope="col">Reason</CTableHeaderCell>
                <CTableHeaderCell scope="col">Provider</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {showNotSeenModal &&
                notSeenListArr &&
                notSeenListArr.length > 0 &&
                notSeenListArr.map((p, index) => {
                  return (
                    <CTableRow key={p.id}>
                      <CTableHeaderCell scope="row">{p.id}</CTableHeaderCell>
                      <CTableDataCell>{p.patientName}</CTableDataCell>
                      <CTableDataCell>{p.startDate}</CTableDataCell>
                      <CTableDataCell>{p.notSeenReason}</CTableDataCell>
                      <CTableDataCell>{p.providerName}</CTableDataCell>
                    </CTableRow>
                  )
                })}
            </CTableBody>
          </CTable>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" variant="outline" onClick={() => setShowNotSeenModal(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>

      <Pageloader
        isLoading={
          isPageLoading ||
          loadingStates.fetchingFacilities ||
          loadingStates.fetchingProviders ||
          loadingStates.fetchingAppointments ||
          loadingStates.fetchingPatients ||
          (activeTab === 'tasks' && loadingStates.fetchingCredentialTasks)
        }
      />
    </>
  )
}

export default Analytics
